import styled from "styled-components";

// eslint-disable-next-line import/prefer-default-export
export const DatabaseContentStyle = styled.div`
	padding: 30px;
	display: flex;
	background-color: #F5F5F5;
`;
